import React from 'react'


export default function Gifts() {
    
    const winnername = JSON.parse(localStorage.getItem('winnersname'));
    const winnerImage = JSON.parse(localStorage.getItem('winnersImage'));
    const gift=JSON.parse(localStorage.getItem('gift'));

    const randomnum = Math.floor(Math.random() * winnername.length)

    
    const info= {
        "username":`${winnername[randomnum]}`,
        "gift":`${gift}`
    }
    

    localStorage.setItem('yourgift', JSON.stringify(info));
    
    
    


    return (

        <>
            {
                winnerImage.length === 0 ?
                    (
                        null
                    )
                    :
                    (
                        <div className='bg-dwam border-t-2 border-yakam p-4'>
                            <div className=''>
                                <p className='text-center text-shasham text-xl md:text-3xl'>براوەی ئەمڕۆ</p>
                                <div className='flex justify-center items-center flex-col p-3'>
                                    <img className='md:w-48 md:h-48 w-32 h-32 rounded-full' src={winnerImage[randomnum]} alt={winnerImage[randomnum]} />
                                    <div className='h-8 w-12  hidden md:block absolute bg-yellow-500 mt-[90px] md:mt-[150px] mr-36 md:mr-44'></div>
                                    <div className='h-8 w-12  hidden md:block absolute bg-yellow-500 mt-[90px] md:mt-[150px] ml-36 md:ml-44'></div>
                                    <div className=' w-36 h-8 hidden md:block md:w-44 absolute mt-20 md:mt-32 text-center items-center p-1 bg-yellow-400'><p>{winnername[randomnum]}</p></div>
                                </div>
                            </div>
                        </div>
                    )

            }
        </>

    )
}


